export default __webpack_public_path__ + "static/media/tadilat-nedir.006e70c6.jpg";